type Section = {
  superId: string;
  revisionId: string;
  locale?: string;
  targetLanguages?: { locale: string; superId: string; revisionId: string }[];
};

type LanguageDocument = {
  content: {
    locale?: string;
    sections: Section[];
  };
};

type Language = {
  isDefault: boolean;
  locale: string;
  superId: string;
  revisionId: string;
};

export function mapLanguages(document: LanguageDocument, sectionId: string): Language[] {
  const defaultLocale = document.content.locale || 'sv-SE';
  const languages: Language[] = [];
  document.content.sections
    .filter((section) => section.superId === sectionId)
    .forEach((section) => {
      languages.push({
        isDefault: true,
        locale: section.locale || defaultLocale,
        superId: section.superId,
        revisionId: section.revisionId,
      });

      if (section.targetLanguages) {
        section.targetLanguages.forEach((targetLang) => {
          languages.push({
            isDefault: false,
            locale: targetLang.locale,
            superId: targetLang.superId,
            revisionId: targetLang.revisionId,
          });
        });
      }
    });

  return languages;
}
